import $ from 'jquery'
import './vendor/jquery.easing.1.3.js'
import './plugins/pagescroll.js'

const w = window,
      pathname = location.pathname;

// Google Tag manager
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(w,document,'script','dataLayer','GTM-K74W32Q');

$(()=>{

  // menu toggle
  $('[data-plugin=menutoggle]').on('click',function(){
    $('body').toggleClass( function(){
      if ( $(this).hasClass('is-menuready') ){
        setTimeout(()=>{ $('body').removeClass('is-menuready') },500);
        return ''
      }else{
        return 'is-menuready'
      }

    })
    $('body').toggleClass( $(this).data('toggle-class') )
  })
  $('[data-plugin=menutoggle]').each(function(){
    const self = this
    $(document).on('click','.menu-item a[href*="#"]',() => {
      setTimeout(()=>{
        $(self).trigger('click');
      },350);
    })
  });
  (function(d, s, id){
    $('<div />',{id:'fb-root',class:'fb'}).prependTo('body');
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.12&appId=759600244139396&autoLogAppEvents=1';
    fjs.parentNode.insertBefore(js, fjs);
  })(document,'script', 'facebook-jssdk');


  $('[data-load-html]').each(function(){
    const $this = $(this),
          filepath = $this.data('load-html');
    $.get(`/assets/source/${filepath}.html`).done((html)=>{
      $this.replaceWith(html);
    });
  });

})

if(pathname.indexOf(/^\/organization/) != 0){
  $(()=>{

    // accordion
    $('[data-plugin=accordion]').each(function(){
      const $this = $(this);
      $this.next('ul').hide();
      $this.on('click',function(e){
        e.preventDefault();
        $(this)
          .toggleClass('is-accordion-active')
          .next('ul')
          .slideToggle('fast');
        return false;
      });
    });

  });
}
